import { run } from '@hellopret/tripetto-runner-autoscroll';
import { Export } from 'tripetto-runner-foundation';
import { v4 as uuidv4 } from 'uuid';
import _differenceBy from 'lodash.differenceby';
import {addErrorOnBadPhoneNumber} from "../hp_ui";

import { styles, l10n, customCSS, definition, getLastUpdatedStep, trackTripettoPageView, gclid } from './config';

let previousStepName = '';
let fields;
let lastMessageUpdateTrigger;

const getKeyValueDataFromTripetto = (instance) => {
  let params = Export.exportablesWithData(instance);
  let results = {};

  params.fields
        .forEach(node => { results[node.name] = node.string; });

  return results;
}

const getDataFromTripetto = (instance, aliases) => {
  let params = Export.exportablesWithData(instance);

  return params.fields
                  .filter(node => aliases.includes(node.name))
                  .map(node => { return { alias: node.name, value: node.string }});
}

const getSignUpQueryParameters = instance => {
  const aliases = ['/signup/title', '/signup/subtitle'];
  const params = getDataFromTripetto(instance, aliases);

  return btoa(encodeURIComponent(JSON.stringify(params)));
}

const trackTunnelSubmit = instance => {
  const aliases = ['/filter/value'];
  const params = getDataFromTripetto(instance, aliases);
  const value = params && params.length > 0 && params[0].value ? params[0].value : null;

  if (value) {
    trackTripettoPageView(`/mon-projet${value}`);
  } else {
    trackTripettoPageView('/mon-projet/fin');
  }
}

const getRedirectUrl = instance => {
  const aliases = ['/redirect-url'];
  const params = getDataFromTripetto(instance, aliases);
  const value = params && params.length > 0 && params[0].value ? params[0].value : null;

  if (value && value.startsWith('https://app.hellopret.fr')) {
    return value.replace('https://app.hellopret.fr', process.env.FRONT_DASHBOARD_URL);
  } else if (value && value.startsWith('https://')) {
    return value;
  } else if (value && value == 'process.env.FRONT_END_TUNNEL_URL') {
    return process.env.FRONT_END_TUNNEL_URL;
  }
}

const getClientIpAddress = async () => {
  try {
    let res = await fetch('https://api.ipify.org/?format=json')
    res = await res.json()
    return res['ip']
  } catch {
    return '0.0.0.0'
  }
}

const getFilterValue = instance => {
  const aliases = ['/filter/value'];
  const params = getDataFromTripetto(instance, aliases);
  const value = params && params.length > 0 && params[0].value ? params[0].value : null;
  return value;
}

const getZapierHookUrl = instance => {
  const aliases = ['/zapier/hook'];
  const params = getDataFromTripetto(instance, aliases);
  const value = params && params.length > 0 && params[0].value ? params[0].value : null;

  return value;
}

const getZapierHook2Url = instance => {
  const aliases = ['/zapier/hook-2'];
  const params = getDataFromTripetto(instance, aliases);
  const value = params && params.length > 0 && params[0].value ? params[0].value : null;

  return value;
}

const getZapierHook3Url = instance => {
  const aliases = ['/zapier/hook-3'];
  const params = getDataFromTripetto(instance, aliases);
  const value = params && params.length > 0 && params[0].value ? params[0].value : null;

  return value;
}

const postToZapierWebhook = async (zapierHookUrl, instance) => {
  let data = getKeyValueDataFromTripetto(instance)
  data['ip'] = await getClientIpAddress()
  data['id'] = uuidv4();
  data['created_at'] = new Date();

  if (gclid) {
    data['gclid'] = gclid
  }

  await fetch(
    zapierHookUrl,
    {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify(data),
    }
  )
}

const shouldSaveTunnel = redirectUrl => {
  /*
  console.log('shouldSaveTunnel')
  console.log(redirectUrl)
  console.log(process.env.FRONT_END_TUNNEL_URL)
  return true
  */
  if (!redirectUrl) {
    return false
  } else if (redirectUrl == process.env.FRONT_END_TUNNEL_URL || redirectUrl.startsWith('https://app.hellopret.fr/')) {
    return true
  }
}

const saveTunnel = async instance => {
  const query = `mutation publicTunnel($input: CreatePublicTunnelInput!) {
    createPublicTunnel(input: $input) {
      id
    }
  }`

  const variables = {
    input: {
      payload: Export.exportablesWithData(instance)
    }
  }

  const res = await fetch(
    process.env.FRONT_API_URL,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, variables }),
    }
  )

  if (res.ok) {
    const { data } = await res.json()
    return data.createPublicTunnel.id;
  }
}

const getNewFields = (data) => {
  const newFields = _differenceBy(data.fields, fields, 'value')
  fields = data.fields;
  return newFields
}

const updateSidebar = (newFields) => {
  const sidebarMessages= [
    "Helloprêt a déjà financé plus de 10 000 foyers et détient la meilleure note Google du marché !",
    "Plus votre questionnaire sera détaillé, plus la comparaison des taux sera précise !",
    "Les banques se servent du prêt immobilier comme outil de captation de client...",
    "Nous vous aidons également à faire des économies sur l’assurance de votre prêt immobilier.",
    "En 2024,les taux sont en baisse sur l'ensemble de nos banques partenaires."
  ]
  const sidebarFields = newFields.filter((field) => field.name.startsWith('/sidebar'))
  if(sidebarFields.length>0){
    sidebarFields.forEach((field) => {
      document.querySelector(`[data-tripetto-alias="${field.name}"]`).innerText = field.value
    })
  }else{
    //si le nombre de valeurs est différent et tous les 3 champs.. on change le message
    if(lastMessageUpdateTrigger!= fields.length && fields.length % 3 == 0){
      document.querySelector(`[data-tripetto-alias="/sidebar/description"]`).innerText = sidebarMessages[Math.floor(Math.random() * sidebarMessages.length)];
      lastMessageUpdateTrigger = fields.length;
    }
  }

}

const shouldExitTunnel = (instance) => {
/*  const aliases = ['slugpartenaire'];
  const params = getDataFromTripetto(instance, aliases);
  const partner = params && params.length > 0 && params[0].value ? params[0].value : null;
  console.log('partner: '+partner)*/

  const filerValue = getFilterValue(instance);
  if(filerValue){
    console.log('filerValue: '+filerValue)
  }
  //when partner is "bien-ici"
  /*
  if(partner=='bien-ici'){
    const redirectUrl = getRedirectUrl(instance);
    //const zapierHookUrl = getZapierHookUrl(instance);
    if(redirectUrl){
      console.log('Redirect to: '+redirectUrl);
      //window.location = redirectUrl;
    }
  }
   */
}

const storeInstanceLocally = (instance) => {
  const data = getKeyValueDataFromTripetto(instance);
  localStorage.setItem('tripetto_instance', JSON.stringify(data));
}

const trackTripettoEvent = (event) => {
  console.log('trackTripettoEvent: '+event)
  if(dataLayer){
    dataLayer.push({ event: event })
    console.log('sent')
  }
}

run({
    element: document.getElementById('tripetto'),
    definition,
    customCSS,
    styles,
    l10n,
    customStyle: (window.innerWidth > 768) ?  { height: '600px' } : {},
    persistent: true,
    onData: instance => {
      const data = Export.exportablesWithData(instance);
      const newFields = getNewFields(data);
      updateSidebar(newFields)
      shouldExitTunnel(instance)
      //console.log(data);
      const lastUpdatedStep = getLastUpdatedStep(data);
      const { name } = lastUpdatedStep;

      // this is a new step
      if (name !== previousStepName) {
        previousStepName = name;
        trackTripettoPageView(`/mon-projet${name}`);
      }

      addErrorOnBadPhoneNumber()
    },
    onSubmit: async instance => {
      trackTunnelSubmit(instance);
      const redirectUrl = getRedirectUrl(instance);
      const zapierHookUrl = getZapierHookUrl(instance);

      if (zapierHookUrl) {
        await postToZapierWebhook(zapierHookUrl, instance);
      }

      const zapierHook2Url = getZapierHook2Url(instance);
      if (zapierHook2Url) {
        await postToZapierWebhook(zapierHook2Url, instance);
      }

      const zapierHook3Url = getZapierHook3Url(instance);

      if (zapierHook3Url) {
        await postToZapierWebhook(zapierHook3Url, instance);
      }

      storeInstanceLocally(instance);

      if (shouldSaveTunnel(redirectUrl)) {
        const tid = await saveTunnel(instance);
        console.log('tid: '+tid);
        if (tid) {
          //send GTM an event "user reaches end of tunnel"
          trackTripettoEvent('tunnel_end');

          const signupPageQueryParams = getSignUpQueryParameters(instance);
          window.location.href = `${redirectUrl}&tid=${tid}&gclid=${gclid}&signUpPageParams=${signupPageQueryParams}`;
        }
      } else if(redirectUrl) {
        window.location.href = redirectUrl;
      }
    },
});
